module.exports = __webpack_public_path__ + "static/img/logo_yape.e74c8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payments/logo_yape.png
// module id = 203
// module chunks = 1